import type { PartnerAdminContractPlan } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { ContractPlanDetailPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ContractPlanDetailPresentation>;

type Args = {
  /** 契約プラン詳細データ */
  data: PartnerAdminContractPlan;
};

type IConvertToPresentationProps = (args: Args) => PresentationProps;

/**
 * ギフトプランを表示テキストに変換する
 *
 * - null → 「-」
 * - 非 null → 「{amount}円（{months_interval}ヶ月に1回 利用可）」
 */
const convertGiftPlan = (giftPlan: PartnerAdminContractPlan['gift_plan']): string => {
  if (!giftPlan) {
    return '-';
  }
  return `${giftPlan.amount}円（${giftPlan.months_interval}ヶ月に1回 利用可）`;
};

/**
 * PartnerAdminContractPlan を ContractPlanDetailPresentation の Props に変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => ({
  title: data.name,
  kindBadge:
    data.kind === 'custom'
      ? { label: '個社', status: 'info' as const }
      : { label: '標準', status: 'neutral' as const },
  giftPlan: convertGiftPlan(data.gift_plan),
  customerChargeUnitPrice: `${data.customer_charge_unit_price}円`,
  taxRatePercent: `${data.tax_rate_percent}%`,
  createdAt: formatDate({ date: new Date(data.created_at * 1000), formatType: 'yyyy/MM/dd HH:mm' }),
  updatedAt: formatDate({ date: new Date(data.updated_at * 1000), formatType: 'yyyy/MM/dd HH:mm' }),
});
